import TemplateNotifications from './TemplateNotifications';

export default TemplateNotifications;
